module.exports = __webpack_public_path__ + "media/site_templates/www.bathroomrenovations.biz/images/about_us-0501f59dc120a51351e260781cbe45b7.jpg";